import { useStoryblok } from "@storyblok/react";
import { LoadingComponent } from "./LoadingComponent";
import Config from "./Config";
import { getEnvironmentVersion } from "../utils/getEnvironmentVersion";

export const Layout = ({ children }) => {
  const navStory = useStoryblok("config", {
    version: getEnvironmentVersion(),
    resolve_links: "url",
  });

  return (
    <LoadingComponent loading={!navStory || !navStory.content}>
      <Config blok={navStory.content} />

      {children}
      <footer>
        <div className="footer-wrapper">
          <div className="footer-column">
            <img
              src="https://a.storyblok.com/f/341980/1292x574/75e0fc7261/white-catalyst-logo.png?cv=1752267434797"
              alt="Catalyst Logo"
              className="footerLogo"
            />
          </div>
          <div className="footer-column">
            <h3>Solutions</h3>
            <a href="/solutions">Solutions overview</a>
            <br />
            <a href="/solutions/peer-to-peer-events">Peer-to-peer events</a>
            <br />
            <a href="/solutions/peer-to-peer-fundraising">
              Peer-to-peer fundraising
            </a>
            <br />
            <a href="/solutions/fitness-fundraising">Fitness fundraising</a>

            <br />
          </div>
          <div className="footer-column">
            <h3>Platform</h3>
            <a href="/platform">Platform overview</a>
            <br />
            <a href="/platform/nonprofit-features">Non-profit features</a>
            <br />
            <a href="/platform/fundraiser-features">Fundraiser features</a>
            <br />
            <a href="/platform/integrations">Integrations</a>
          </div>
          <div className="footer-column">
            <h3>Case studies</h3>
            <a href="/case-studies/ruck-for-rare">Ruck 4 Rare</a>
            <br />
            <a href="/case-studies/la-wildfire-relief">LA Wildfire Relief</a>
            <br />
            <a href="/case-studies/friends-of-msf-student-chapters">
              MSF Student Chapters
            </a>
            <br />
            <a href="/case-studies/nbcf-hikma-employee-engagement">
              Hikma Employer Engagement
            </a>
            <br />
            <a href="/case-studies/1-000-miles-for-melanoma">
              1,000 miles for Melanoma
            </a>

            <h3>
              <a href="/blog">Blog</a>
            </h3>
          </div>
          <div className="footer-column">
            <h3>Company</h3>
            <a href="/about">About</a>

            <br />
            <a href="/book-demo">Book a demo</a>
            <div className="social-icons">
              <a href="https://www.linkedin.com/company/tiltify-catalyst/about/">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M27.2661 27.2661H22.5245V19.8407C22.5245 18.07 22.4929 15.7906 20.0585 15.7906C17.5889 15.7906 17.211 17.7198 17.211 19.7117V27.2655H12.4697V11.9959H17.0214V14.0826H17.0852C18.012 12.498 19.7416 11.548 21.5763 11.6162C26.3819 11.6162 27.2681 14.7771 27.2681 18.8894L27.2661 27.2661ZM7.11967 9.90859C7.11938 9.90859 7.11924 9.90859 7.11909 9.90859C5.60963 9.90859 4.36753 8.66663 4.36753 7.15716C4.36753 5.64769 5.60963 4.40558 7.11909 4.40558C8.62842 4.40558 9.87038 5.6474 9.87066 7.15659C9.87066 7.15673 9.87066 7.15687 9.87066 7.15716C9.87066 8.66635 8.62885 9.90845 7.11967 9.90859ZM9.49036 27.2661H4.74396V11.9959H9.49036V27.2661ZM29.6297 0.00240447H2.36125C1.08122 -0.0120519 0.0156014 1.02881 0 2.30884V29.6906C0.0150289 30.9714 1.0805 32.0134 2.36125 31.9998H29.6297C30.9136 32.0158 31.9828 30.9739 32 29.6906V2.30698C31.9828 1.02423 30.9122 -0.016489 29.6297 0.000197905"
                    fill="#ffffff"
                  />
                </svg>
              </a>
              {/* <a href="https://youtube.com/tiltifycatalyst">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_3538_30)">
                    <path
                      d="M16 4C16 4 26.0077 3.99986 28.5049 4.66895C29.8824 5.03782 30.9652 6.12051 31.334 7.49805H31.3311C31.9971 9.98111 32 15.1526 32 15.2002C32 15.2002 32.0001 20.4088 31.3311 22.9033C30.9622 24.2808 29.8795 25.3637 28.502 25.7324C26.0074 26.4015 16 26.4014 16 26.4014C15.9992 26.4014 5.99252 26.4015 3.49805 25.7324C2.12051 25.3637 1.03783 24.2808 0.668945 22.9033C-0.000135991 20.4088 0 15.2002 0 15.2002C1.41587e-05 15.1526 0.002949 9.98111 0.668945 7.49805C1.03775 6.12045 2.12045 5.03775 3.49805 4.66895C5.99252 3.99989 15.9992 4 16 4ZM12.7998 20L21.1152 15.2002L12.7998 10.4014V20Z"
                      fill="#ffffff"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_3538_30">
                      <rect width="32" height="32" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </a> */}
              {/* <a href="https://facebook.com/tiltifycatalyst">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M32 16.0977C32 7.20715 24.8366 -6.10352e-05 16 -6.10352e-05C7.16344 -6.10352e-05 0 7.20715 0 16.0977C0 24.1325 5.85094 30.7923 13.5 31.9999V20.751H9.4375V16.0977H13.5V12.5512C13.5 8.51667 15.8888 6.28813 19.5434 6.28813C21.2941 6.28813 23.125 6.60254 23.125 6.60254V10.5641H21.1075C19.12 10.5641 18.5 11.8051 18.5 13.0781V16.0977H22.9375L22.2281 20.751H18.5V31.9999C26.1491 30.7923 32 24.1328 32 16.0977Z"
                    fill="#F8F8F9"
                  />
                </svg>
              </a>
              <a href="https://x.com/tiltifycatalyst">
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.6638 11.8561L27.0874 0H24.6174L15.5665 10.2945L8.33765 0H0L10.9315 15.5671L0 28H2.47021L12.0281 17.1287L19.6623 28H28L16.6632 11.8561H16.6638ZM13.2805 15.7042L12.1729 14.1541L3.36026 1.81955H7.15435L14.2663 11.7739L15.3739 13.324L24.6185 26.2632H20.8244L13.2805 15.7048V15.7042Z"
                    fill="white"
                  />
                </svg>
              </a> */}
            </div>
          </div>
        </div>
        <div className="sub-footer">
          <p>&copy; Tiltify {(new Date().getFullYear())}</p>
          <a href="https://tiltify.com/pages/terms-of-service" target="_blank" rel="noreferrer">
            Terms
          </a>{" "}
          |{" "}
          <a href="https://tiltify.com/pages/privacy-policy" target="_blank" rel="noreferrer">
            Privacy Policy
          </a>
        </div>
      </footer>
    </LoadingComponent>
  );
};
